import { render, staticRenderFns } from "./Carac.vue?vue&type=template&id=0dfc4013&"
import script from "./Carac.vue?vue&type=script&lang=js&"
export * from "./Carac.vue?vue&type=script&lang=js&"
import style0 from "./Carac.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports